import React from 'react';
import { 
  Facebook, Twitter, Instagram, Linkedin, 
  MapPin, Phone, Mail, Shield, Truck, CreditCard, Headphones, ShoppingCart 
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
            
              <div className="bg-[#ff660e] p-2 rounded-lg">
                <ShoppingCart className="w-7 h-7 text-white" />
              </div>

              <div>
                <h2 className="text-2xl font-bold"> EcoMart</h2>
                <p className="text-gray-400 text-sm"> Buy Smart. Sell Safe.</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Your one-stop destination for buying and selling goods across Nigeria. 
              Safe, secure, and convenient transactions for everyone.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-gray-700 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-gray-700 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-gray-700 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-gray-700 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors">About EcoMart</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Customer Service</h3>
            <ul className="space-y-3">
              <li><Link to="/support" className="text-gray-400 hover:text-orange-400 transition-colors">Help Center</Link></li>
              <li><Link to="/how-to-buy" className="text-gray-400 hover:text-orange-400 transition-colors">How to Buy</Link></li>
              <li><Link to="/how-to-sell" className="text-gray-400 hover:text-orange-400 transition-colors">How to Sell</Link></li>
              <li><Link to="/escrow" className="text-gray-400 hover:text-orange-400 transition-colors">How to use Escrow</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-orange-400 transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-orange-500 mt-0.5 mr-3 flex-shrink-0" />
                <p className="text-gray-400 text-sm">
                  Lagos, Nigeria
                </p>
              </div>
           
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-orange-500 mr-3 flex-shrink-0" />
                <p className="text-gray-400 text-sm">support@ecomart.ng</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="bg-gray-800 rounded-xl p-6 mb-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-3 rounded-lg mr-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-white">Safe & Secure</h4>
                <p className="text-gray-400 text-sm">Protected Transactions</p>
              </div>
            </div>
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-3 rounded-lg mr-4">
                <Truck className="w-8 h-8 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-white">Nationwide</h4>
                <p className="text-gray-400 text-sm">Across All States</p>
              </div>
            </div>
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-purple-500 to-pink-600 p-3 rounded-lg mr-4">
                <CreditCard className="w-8 h-8 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-white">PayStack</h4>
                <p className="text-gray-400 text-sm">Card, Transfer, Cash</p>
              </div>
            </div>
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-orange-500 to-red-500 p-3 rounded-lg mr-4">
                <Headphones className="w-8 h-8 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-white">24/7 Support</h4>
                <p className="text-gray-400 text-sm">Always Here to Help</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0 text-center md:text-left">
              © {currentYear} EcoMart Nigeria. All rights reserved.
            </div>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm">
              <Link to="/legal#privacy" className="text-gray-400 hover:text-orange-400 transition-colors">Privacy Policy</Link>
              <Link to="/legal#terms" className="text-gray-400 hover:text-orange-400 transition-colors">Terms of Service</Link>
              <Link to="/legal#cookies" className="text-gray-400 hover:text-orange-400 transition-colors">Cookie Policy</Link>
              <Link to="/legal#legal" className="text-gray-400 hover:text-orange-400 transition-colors">Legal</Link>
            </div>
          </div>
          <div className="mt-4 text-center text-gray-500 text-xs">
            EcoMart Nigeria Operating under SalsTech IT Solutions (RC: 7398490). All product names, logos, and brands are property of their respective owners.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;